<template>
  <div>
    <el-radio-group v-model="selectedParkId" size="small">
      <el-radio-button v-for="park in parks" :key="park.id" :label="park.id">
        {{ park.name }}
      </el-radio-button>
    </el-radio-group>
    <p />

    <!-- 当没有选中地块时显示的内容（地块列表） -->
    <template v-if="selectedLand === undefined">
      <div v-if="landsArr.length === 0">
        <el-alert type="error" effect="dark" :closable="false">
          这个园区暂时没有登记地块的信息，所以无法提供显示内容，请先完善地块信息。
        </el-alert>
      </div>
      <el-row v-else :gutter="10">
        <template v-for="(item, index) in landsArr">
          <el-col :span="4" :key="index" style="margin-bottom: 10px">
            <el-card>
              <div>
                <img
                  src="./house-icon.jpg"
                  alt=""
                  style="border-radius: 30px; float: left"
                />
                <div>
                  <el-link @click="selectedLand = item" :disabled="item.idle">
                    &nbsp;{{ item.name }} <i class="el-icon-link" />
                  </el-link>

                  <div
                    style="
                      font-size: 12px;
                      color: #999;
                      padding-left: 64px;
                      margin-top: 4px;
                      min-height: 48px;
                    "
                  >
                    {{ item.info }}
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
        </template>
      </el-row>
    </template>

    <!-- 当有地块被选中时显示的内容（地块导览） -->
    <template v-else>
      <land-guide @quit="guideQuit" :land="selectedLand" />
    </template>
  </div>
</template>

<script>
import { getParksInEnterprise } from '@/api/park2.js'
import { getLandInPark } from '@/api/land2.js'
import { getPlanByLand } from '@/api/plan2'

import LandGuide from './LandGuide.vue'
export default {
  name: 'Home',
  components: { LandGuide },
  data() {
    return {
      /**
       * 选中的tab，绑定单选组组件
       */
      selectedParkId: undefined,
      selectedLand: undefined,
      /**
       * 所有园区选项
       */
      parks: undefined,
      /**
       * 园区数组
       */
      landsArr: [],
    }
  },
  computed: {
    /**
     * 当前公司id
     */
    enterpriseId() {
      return this.$store.getters.currentEnterprise.id
    },
    /**
     * 当前选中的园区
     */
    currentPark() {
      const { parks, selectedParkId } = this
      // console.log(parks)
      if (!parks || parks.length === 0) return undefined
      return parks.find((p) => {
        return p.id === selectedParkId
      })
    },
  },

  mounted() {
    let enterpriseId = this.$store.getters.currentEnterprise.id
    console.log(enterpriseId)
    // 获取当前公司的园区列表，作为选项
    getParksInEnterprise(enterpriseId).then((resp) => {
      console.log('parks = ', resp.data)
      // 设置parks值，先使tabs可用
      this.parks = resp.data
      this.selectedParkId = this.parks[0].id
    })
  },
  watch: {
    /**
     * 监听当前园区改变
     */
    currentPark: function (val) {
      // 重置选中地块
      this.selectedLand = undefined

      // 加载新的地块列表
      getLandInPark(this.currentPark.id).then((resp) => {
        console.log('lands = ', resp.data)
        if (resp.data.length !== 0) {
          let arr = []
          resp.data.forEach((item) => {
            getPlanByLand(item.id)
              .then((r) => {
                if (r.data.planId !== null) {
                  item.info = `${new Date(r.data.harvest).format(
                    'yyyy年MM月dd日 '
                  )} 栽种，品种 ${r.data.variName}，预计 ${new Date(
                    r.data.harvest
                  ).format('yyyy年MM月dd日')} 上市`
                  item.idle = false
                } else {
                  item.info = '此地块目前空闲。'
                  item.idle = true
                }
              })
              .then(() => {
                arr.push(item)
                console.log(this.landsArr)
              })
              .then(() => {
                let obj = {}
                arr = arr.reduce(function (item, next) {
                  obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
                  return item
                }, [])
                this.landsArr = arr
              })
          })
        } else {
          this.landsArr = []
        }
      })
    },
  },
  methods: {
    guideQuit() {
      this.selectedLand = undefined
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/welcome/Index.vue